import { ColDef } from "@/components/GridTable";
import { WatchlistTab } from "../types";
import { ValueFormatterParams } from "ag-grid-community";
import { round } from "lodash";
import { formatLargeValue } from "@/utils/number";
import { oc } from "ts-optchain";

export const defaultColDef: ColDef = {
  editable: false,
  resizable: true,
  suppressMovable: true,
  sortable: true,
  filter: true,
  filterParams: { newRowsAction: "keep", resetButton: true }
};

function rounding(params: ValueFormatterParams, isPercent = true) {
  return `${round(params.value, 2).toString()} ${isPercent ? "%" : ""}`;
}

function colorText(params: ValueFormatterParams) {
  return params.value >= 0 ? { color: "#00a97f" } : { color: "red" };
}

export const editorColumns: ColDef<any>[] = [
  { headerName: "Company Name", field: "trading_name", pinned: "left", minWidth: 150 },
  { headerName: "Ticker", field: "trading_code", minWidth: 80 },
  { headerName: "Exchange", field: "exchange" },
  { headerName: "Last", field: "last", filter: "agNumberColumnFilter" },
  {
    headerName: "Chg",
    field: "chng",
    filter: "agNumberColumnFilter",
    sortable: true,
    valueFormatter: p => rounding(p, false),
    cellStyle: colorText
  },
  {
    headerName: "Chg %",
    field: "chng_pct",
    filter: "agNumberColumnFilter",
    sortable: true,
    valueFormatter: rounding,
    cellStyle: colorText
  },
  { headerName: "Open", field: "open", filter: "agNumberColumnFilter" },
  { headerName: "High", field: "high", filter: "agNumberColumnFilter" },
  { headerName: "Low", field: "low", filter: "agNumberColumnFilter" },
  {
    headerName: "Volume",
    field: "volume",
    filter: "agNumberColumnFilter",
    valueFormatter: p => formatLargeValue(oc(p).value(0))
  },
  { headerName: "BuyVolume", field: "bid_vol", filter: "agNumberColumnFilter" },
  { headerName: "Bid", field: "bid", filter: "agNumberColumnFilter" },
  { headerName: "Ask", field: "ask", filter: "agNumberColumnFilter" },
  { headerName: "SellVolume", field: "ask_vol", filter: "agNumberColumnFilter" },
  { headerName: "Sector", field: "sector", minWidth: 200 },
  { headerName: "Industry", field: "industry", minWidth: 200 },
  { headerName: "", field: "fullTicker", pinned: "right", cellRenderer: "deleteBtn", width: 10 }
];

export const alertColumns: ColDef<any>[] = [
  {
    headerName: "Notify",
    field: "isNotify",
    cellRenderer: "checkbox",
    sortable: false,
    resizable: false,
    maxWidth: 40,
    pinned: "left"
  },
  { headerName: "Ticker", field: "trading_code", minWidth: 80, pinned: "left" },
  { headerName: "Company Name", field: "trading_name", editable: false, minWidth: 150 },
  { headerName: "Last", field: "last", filter: "agNumberColumnFilter" },
  { headerName: "Chg", field: "chng", filter: "agNumberColumnFilter" },
  { headerName: "Chg %", field: "chng_pct", filter: "agNumberColumnFilter" },
  { headerName: "UAL", field: "upperAlert", filter: "agNumberColumnFilter" },
  { headerName: "UWL", field: "upperWarning", filter: "agNumberColumnFilter" },
  { headerName: "LWL", field: "lowerWarning", filter: "agNumberColumnFilter" },
  { headerName: "LAL", field: "lowerAlert", filter: "agNumberColumnFilter" },
  { headerName: "Exchange", field: "exchange" }
];

export const defaultTab: WatchlistTab[] = [{ title: "All", content: "all", key: "all", closable: false }];
